// extracted by mini-css-extract-plugin
export default {"wrapper":"bhoN3inzY_VnN75MJ4_Q","scopeTag":"hlCVmK_qIMqoNUlCbbq8"};